import React from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { fmtNum } from "@/lib/format";

export function Pager({ page, pageSize, total, onPage }: { page: number; pageSize: number; total: number; onPage: (p: number) => void }) {
  const pages = Math.max(1, Math.ceil(total / pageSize));
  const from = total ? (page - 1) * pageSize + 1 : 0;
  const to = Math.min(page * pageSize, total);
  return (
    <nav className="flex flex-wrap items-center justify-between gap-3 px-4 py-3 border-t border-slate-200 text-sm text-slate-600" aria-label="Paginación">
      <span>{fmtNum(from)}–{fmtNum(to)} de {fmtNum(total)}</span>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)} className="rounded-full h-9" data-testid="pager-prev">
          <ChevronLeft className="w-4 h-4" aria-hidden="true" /> Anterior
        </Button>
        <span aria-current="page">Página {fmtNum(page)} de {fmtNum(pages)}</span>
        <Button size="sm" variant="outline" disabled={page >= pages} onClick={() => onPage(page + 1)} className="rounded-full h-9" data-testid="pager-next">
          Siguiente <ChevronRight className="w-4 h-4" aria-hidden="true" />
        </Button>
      </div>
    </nav>
  );
}
